import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Set+Nickname+API

function setNickname(nickname, provider, source) {
    let url = '/api/users/profile/nickname';
    const { enableProfileAccountGroup = false } = Sephora.configurationSettings;

    if (enableProfileAccountGroup && cookieUtils.isRCPAccountAPIEnabled()) {
        url = '/gway/v2/users/profiles/nickname';
    }

    const params = {
        isAcceptCommunity: true,
        nickName: nickname,
        provider
    };

    if (source) {
        params.source = source;
    }

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(params)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default setNickname;
